import store from "@/store";

/** @returns { Record<string, any> | null } */
export const getUser = () => store.state.luneAuth.user ?? JSON.parse(localStorage.getItem("user")) ?? null;
